import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { useFavorites } from "@/hooks/useFavorites";

const navItems = [
  { to: "/", label: "首页" },
  { to: "/episodes", label: "全部剧集" },
  { to: "/search", label: "搜索" },
  { to: "/about", label: "关于" },
];

export default function SiteHeader() {
  const location = useLocation();
  const isHome = location.pathname === "/";
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const { favoriteIds } = useFavorites();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 32);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
    window.scrollTo({ top: 0, behavior: "auto" });
  }, [location.pathname]);

  const solid = scrolled || !isHome || menuOpen;

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-300 ${
        solid
          ? "bg-background-950/90 backdrop-blur-md border-b border-background-200/60"
          : "bg-gradient-to-b from-background-950/80 to-transparent"
      }`}
    >
      <div className="w-full px-4 md:px-8 h-16 flex items-center justify-between gap-4">
        <Link to="/" className="flex items-center gap-3 min-w-0 group">
          <span className="w-9 h-9 rounded-md bg-primary-500 text-background-50 flex items-center justify-center font-heading text-base font-semibold shrink-0">
            4
          </span>
          <span className="min-w-0">
            <span className="block font-heading text-base md:text-lg font-semibold tracking-wide text-foreground-950 whitespace-nowrap">
              朋友的妈妈4
            </span>
            <span className="hidden sm:block text-[10px] tracking-[0.3em] text-foreground-500 uppercase">
              Drama Archive
            </span>
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-1">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === "/"}
              className={({ isActive }) =>
                `px-4 py-2 rounded-md text-sm whitespace-nowrap transition-colors cursor-pointer ${
                  isActive
                    ? "text-foreground-950 bg-background-100"
                    : "text-foreground-600 hover:text-foreground-950 hover:bg-background-100/70"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <Link
            to="/episodes"
            className="hidden sm:inline-flex items-center gap-2 h-9 px-3 rounded-md border border-background-300/60 text-xs text-foreground-700 hover:border-primary-500 hover:text-foreground-950 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-heart-line text-sm leading-none flex items-center justify-center w-4 h-4" />
            <span>收藏 {favoriteIds.length}</span>
          </Link>
          <Link
            to="/search"
            aria-label="搜索剧集"
            className="w-9 h-9 rounded-md border border-background-300/60 text-foreground-700 hover:text-foreground-950 hover:border-primary-500 transition-colors cursor-pointer flex items-center justify-center"
          >
            <i className="ri-search-line text-base" />
          </Link>
          <button
            type="button"
            aria-label="打开菜单"
            aria-expanded={menuOpen}
            onClick={() => setMenuOpen((open) => !open)}
            className="md:hidden w-9 h-9 rounded-md border border-background-300/60 text-foreground-800 hover:border-primary-500 transition-colors cursor-pointer flex items-center justify-center"
          >
            <i className={menuOpen ? "ri-close-line text-lg" : "ri-menu-2-line text-lg"} />
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="md:hidden border-t border-background-200/60 bg-background-950/97 backdrop-blur-md anim-fade-in">
          <nav className="px-4 py-3 flex flex-col gap-1">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                className={({ isActive }) =>
                  `flex items-center justify-between px-3 py-3 rounded-md text-sm cursor-pointer ${
                    isActive
                      ? "bg-primary-500/15 text-foreground-950"
                      : "text-foreground-700 hover:bg-background-100"
                  }`
                }
              >
                <span>{item.label}</span>
                <i className="ri-arrow-right-s-line text-foreground-500" />
              </NavLink>
            ))}
            <Link
              to="/episodes"
              className="mt-2 flex items-center justify-center gap-2 h-10 rounded-md bg-primary-500 text-background-50 text-sm whitespace-nowrap cursor-pointer"
            >
              <i className="ri-heart-line" />
              我的收藏（{favoriteIds.length}）
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
}